import styled from "styled-components"

export const ControlsMonthlyViewWrapper = styled.div`
	width: 100%;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	gap: 30px;
	> p {
		margin: 0;
		color: #435363;
		font-size: 24px;
		font-weight: 700;
		letter-spacing: -0.04em;
	}
`
